/**
 * Persisted "show section borders" setting (new-format assets, MODEL and REGIONS only;
 * SECTIONS always shows the borders). Section reads it when it applies a view mode,
 * so it lives in a static holder rather than on Asset: Section has no asset reference.
 *
 * Stored in localStorage (synchronous; the async StorageService/IndexedDB cannot be
 * read from Section's view-mode setters). A missing or unreadable value means true.
 */
export class SectionBorderSettings {

    public static readonly STORAGE_KEY = 'PhDsoft:C4DWeb:showSectionBorders';

    private static _show: boolean | null = null;

    /** Current value; read from storage on first use. */
    public static get show(): boolean {
        if (SectionBorderSettings._show === null) {
            SectionBorderSettings._show = SectionBorderSettings.readStored();
        }
        return SectionBorderSettings._show;
    }

    /** Sets the value and persists it. */
    public static set show(v: boolean) {
        SectionBorderSettings._show = v !== false;
        try {
            localStorage.setItem(SectionBorderSettings.STORAGE_KEY, JSON.stringify(SectionBorderSettings._show));
        } catch {
            // Storage unavailable (private mode, quota): keep the in-memory value only
        }
    }

    /** Re-reads the stored value (asset load), so a change made in another tab is picked up. */
    public static reload(): boolean {
        SectionBorderSettings._show = SectionBorderSettings.readStored();
        return SectionBorderSettings._show;
    }

    private static readStored(): boolean {
        try {
            const raw = localStorage.getItem(SectionBorderSettings.STORAGE_KEY);
            if (raw === null) return true;
            return JSON.parse(raw) !== false;
        } catch {
            return true;
        }
    }
}
